import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import firebase from 'firebase/app';
import analytics from 'firebase/analytics';
import firestore from "firebase/firestore";
import 'firebase/auth';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(CoreuiVue)
Vue.use(VueAxios, axios)
Vue.use(VueLodash, { lodash: lodash })

Vue.prototype.$log = console.log.bind(console)

var firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

firebase.auth().onAuthStateChanged(user => {
    if(user){
        firebase.auth().currentUser.getIdTokenResult()
            .then((idTokenResult) => {
                store.commit('userClaims', idTokenResult.claims);
            })
            .catch((error) => {
                 console.log(error);
        });
        store.commit('setUser', user);
    }else{
        store.commit('setUser', undefined);
        store.commit('userClaims', {});
        router.push("/pages/login");
    }
});

if(process.env.NODE_ENV === 'development'){
    firebase.firestore().useEmulator("localhost", 8080);
    firebase.auth().useEmulator('http://localhost:9099/')
}

Vue.filter('formatDate', function(value) {
    return new Date(value).toLocaleString('zh-TW',{timeZone: 'Asia/Taipei'});
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.state.user) {
          next({
              path: '/pages/login',
              query: {
                redirect: to.fullPath
              }
          })
      } else {
          let user = store.state.user;
          if(to.matched.some(record => record.meta.is_admin)) {
              if(user.is_admin == 1){
                  next()
              }
              else{
                  next({ name: 'Dashboard'})
              }
          }else {
              next()
          }
      }
  } else if(to.matched.some(record => record.meta.guest)) {
      if(!store.state.user){
          next()
      }
      else{
          next({ name: 'Dashboard'})
      }
  }else {
      next()
  }
})


new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  }
})
